import { render, staticRenderFns } from "./DisplayModeToggle.vue?vue&type=template&id=d2c9b77e&"
import script from "./DisplayModeToggle.vue?vue&type=script&lang=js&"
export * from "./DisplayModeToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2c9b77e')) {
      api.createRecord('d2c9b77e', component.options)
    } else {
      api.reload('d2c9b77e', component.options)
    }
    module.hot.accept("./DisplayModeToggle.vue?vue&type=template&id=d2c9b77e&", function () {
      api.rerender('d2c9b77e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/dahreply/DisplayModeToggle.vue"
export default component.exports